import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components'
import { rgba } from 'polished';
import { filter, findIndex } from 'lodash'

import { SlideshowModal } from '../../components'

import { updateSettings } from '../../settings'
import { fetchReferences, getReferences } from './redux';

import { media } from '../../styles/utils'
import { green, greenSecondary, cream, lightGrey, cream2 } from '../../styles/colors'
import { hoverState, padding, bgImage } from '../../styles/global'

import FilterOpen from 'svg-react-loader?name=Icon!../../assets/icons/filter-open.svg';
import FilterClose from 'svg-react-loader?name=Icon!../../assets/icons/filter-close.svg';

class ImageReferences extends Component {

    state = {
        query: null,
        activeCategory: 'all',
        activeTags: [],
        activeStore: '',
        activeYears: '',
        activeLocation: '',
    }

    static fetchData(store, match) {
        return store.dispatch(fetchReferences()); 
    }

    componentDidMount() {
        const { updateSettings } = this.props;

        this.props.fetchReferences();

        updateSettings({
            pageTitle: 'Image References',
        })
    }

    onSearchChange = (event) => {
		this.setState({query: event.target.value});
	}
	
	handleSearchKeyPress = (event) => {
		if (event.key === 'Enter') {
			this.props.callback(this.state.query)
		}
    }

    filterResults = (results) => {
        const { activeCategory, activeTags, activeStore, activeLocation, activeYears, query } = this.state;

        let filteredResults = results

        if (activeTags.length > 0) {
            let multipleResults = [];

            activeTags.forEach(element => {
                multipleResults = [
                    ...multipleResults,
                    ...filter(filteredResults, {tags: [{ slug: element }]})
                ]
            });

            filteredResults = multipleResults;
        }

        if (activeStore) {
            filteredResults = filter(filteredResults, { store: { slug: activeStore } });
        }

        if (activeLocation) {
            filteredResults = filter(filteredResults, { location: { slug: activeLocation } });
        }

        if (activeYears) {
            filteredResults = filter(filteredResults, { year: activeYears });
        }

        if (activeCategory !== 'all') {
            filteredResults = filter(filteredResults, { category: { slug: activeCategory } });
        }

        if (query && query !== '') {
            filteredResults = filter(filteredResults, (object) => {
                if (object.caption && object.caption.includes(query)) return true
            });
        }

        return filteredResults
    }

    onFilterChange = (filterType, termSlug, active) => {
        const { activeTags } = this.state;
        
        if (filterType == 'Tag') {

            let newTags = activeTags;

            if (active) {
                newTags = filter(activeTags, (element) => {
                    return element !== termSlug
                });
            } else {
                newTags.push(termSlug)
            }

            this.setState({
                [`activeTags`]: newTags
            })
        } else {
            this.setState({
                [`active${filterType}`]: active ? null : termSlug
            })
        }
    }

    toggleFilterAccordian = (filterType) => {
        const currentState = this.state[`filter${filterType}Open`] ? !this.state[`filter${filterType}Open`] : true;

        this.setState({
            [`filter${filterType}Open`]: currentState
        })
    }
    
    renderFilter = (taxonomy, filterName) => {
        const { references } = this.props;

        if (references.data) {

            const filterTerms = references.data.refs[taxonomy];

            const filters = filterTerms.map((term, index) => {
                //.log(filterName)

                let isActive;
                
                if (filterName == 'Tag') {
                    isActive = this.state[`activeTags`].includes(term.slug)
                } else {
                    isActive = this.state[`active${filterName}`] == term.slug;
                }
                
                return (
                    <Filter
                        key={index}
                        active={isActive}
                        onClick={() => this.onFilterChange(filterName, term.slug, isActive)}
                    >
                        {term.name}
                    </Filter>
                )
            })

            return (
                <FilterContainer>
                    <FilterHeader
                        onClick={() => this.toggleFilterAccordian(taxonomy)}
                    >
                        <Title>{filterName}</Title>
                        {this.state[`filter${taxonomy}Open`] ? <FilterClose/> : <FilterOpen/>}
                    </FilterHeader>
                    <FilterList
                        active={this.state[`filter${taxonomy}Open`] }
                    >
                        {filters}
                    </FilterList>
                </FilterContainer>
            )
        }
    }

    renderCategories = () => {
        const { activeCategory } = this.state;
        const { references } = this.props;

        if (references.data) {

            const filters = references.data.refs.categories.map((term, index) => {
                return (
                    <CheckboxFilter
                        key={index}
                        active={activeCategory == term.slug}
                        onClick={() => this.onFilterChange('Category', term.slug)}
                    >
                        <Checkbox/>
                        {term.name}
                    </CheckboxFilter>
                )
            })

            return (
                <FilterContainer
                    type={'category'}
                >
                    <Title></Title>
                    <FilterHeader
                        onClick={() => this.toggleFilterAccordian('Category')}
                    >
                        <Title>Category</Title>
                        {this.state[`filterCategoryOpen`] ? <FilterClose/> : <FilterOpen/>}
                    </FilterHeader>

                    <FilterList
                        active={this.state[`filterCategoryOpen`] }
                    >
                        <CheckboxFilter
                            active={activeCategory == 'all'}
                            onClick={() => this.onFilterChange('Category', 'all')}
                        >
                            <Checkbox/>
                            All
                        </CheckboxFilter>

                        {filters}
                    </FilterList>

                </FilterContainer>
            )
        }
    }
    
    renderSearch = () => {
        const { query } = this.state;
        const { references } = this.props;


        if (references.data) {
            return (
                <Search>   
                    <SearchIcon/>
                    <SearchInput
                        placeholder="Search..."
                        onKeyPress={this.handleSearchKeyPress}
                        onChange={this.onSearchChange}
                        value={query}
                    />
                </Search>
            )
        }
    }
    
    renderResults = () => {
        const { references } = this.props;

        if (references.data) {
            let filteredResults = this.filterResults(references.data.refs.items);

            const results = filteredResults.map((ref, index) => {
                //console.log(ref)

                if (ref.images.length) {
                    const placeholder = (
                        <Reference>
                            <Image
                                image={ref.images[0].thumbnail}
                            />
                            
                            <Info>
                                Aesop {ref.store && ref.store.name} {ref.year} ({ref.category && ref.category.name})
                                <br/>
                                {ref.caption}
                            </Info>
                            
                        </Reference>
                    )
    
                    return (
                        <SlideshowModal 
                            key={index}
                            imageReference={true}
                            images={ref.images}
                            caption={ref.caption}
                            placeholder={placeholder}
                        />
                    )
                }
            })
    
            if (results) {
                return (
                    <ResultsGrid>
                        {results}
                    </ResultsGrid>
                )
            }
        }

       
    }
    
    render() {        
        return (
            <Container>

                <Filters>
                    {this.renderFilter('tags', 'Tag')}
                    {this.renderFilter('stores', 'Store')}
                    {this.renderFilter('locations', 'Location')}
                    {this.renderFilter('years', 'Years')}
                    {this.renderCategories()}
                </Filters>

                {this.renderSearch()} 
                {this.renderResults()}

            </Container>
        )
    }
}

const Container = styled.div`
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: ${cream};
    overflow-y: scroll;
    max-height: calc(100vh - 65px); 

    ${media.phone`
        flex-direction: column;
        max-height: calc(100vh - 49px); 
    `}
`

const Title = styled.div``

const Description = styled.div``

const Intro = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 1rem 1rem 0;
    border-bottom: 1px solid;

    ${Title} {
        font-size: 28px;
        font-weight: 400;
        line-height: 37.8px;
    }

    ${Description} {
        flex: 0 1 50%;
        font-size: 1rem;
        line-height: 1.35rem;
        margin-bottom: 1.35em;
        line-height: 21.6px;
    }
`

// Search

const Search = styled.div`
    background: ${cream2};
    display: block;
    flex-direction: row;
    align-items: center;
    position: relative;
    border-bottom: 1px solid;
    height: 57px;
    min-height: 57px;
`;

const SearchIcon = styled.div`
    
`;

const SearchInput = styled.input`
    background: none;
    border: none;

    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    font-size: 24px;
    line-height: 35px;
    padding: 0.8rem 1rem 0.8rem 0.8rem;
    
    &, &::placeholder {
        color: black;
    }

    &:focus { 
        outline: none;
    }

    ${media.phone`
        font-size: 22px;
        height: 49px;
        padding: 0;
        ${padding};
    `}
`

// Category Filters

const Filters = styled.div`
    display: block;
`

const FilterContainer = styled.div`
    display: flex;
    padding-top: 12px;
    padding-bottom: 23px;
    border-bottom: 1px solid black;
    flex: 0 1 auto;
    flex-direction: column;
    padding: 0;

    ${props => {
        if (props.type == 'category') return css`
       

            ${media.desktop`
                ${FilterList} {
                    padding-top: 22px;
                    columns: auto;
                }
            `}
        `
    }}
`

const FilterHeader = styled.div`
    flex: 0 1 200px;
    pointer-events: none;
    user-select: none;

    ${Title} { 
        font-size: 24px;
    }

    > *:nth-child(2) {
        display: none;
    }

    flex: 0;
    display: flex;
    height: 57px;
    min-height: 57px;
    justify-content: space-between;
    align-items: center;
    ${padding}
    pointer-events: all;

    > *:nth-child(2) {
        display: flex;
    }

    ${media.phone`
        height: 34px;

        ${Title} {
            font-size: 16px;
        }
    `}
`

const FilterList = styled.div`
    columns: 3;
    flex: 1;

    display: none;

    ${props => {
        if (props.active == true) return css`
            display: block; 
            border-top: 1px solid black;
            ${padding}
            padding-top: 12px;
            padding-bottom: 14px;

            ${media.phone`
                padding-top: 8px;
                padding-bottom: 12px;
            `}
        `
    }}

    ${media.phone`
        columns: auto;
    `}
`

const Filter = styled.div`
    font-size: 16px;
    ${hoverState}
    cursor: pointer;
    user-select: none;

    ${props => {
        if (props.active) return css`
            font-weight: bold;
        `
    }}
`

// Checkbox Filter

const Checkbox = styled.div`
    width: 20px;
    height: 20px;
    border: 1px solid black;
    border-radius: 50%;
    margin-right: 8px;
`

const CheckboxFilter = styled.div`
    display: flex;
    align-items: center;
    font-size: 24px;
    opacity: 0.3;
    user-select: none;

    ${media.phone`
        font-size: 22px;
    
        &:last-child {
            /* margin-bottom: 10px; */
        }
    `}
    
    ${props => {
        if (props.active) return css`
            opacity: 1; 

            ${Checkbox} {
                background: black;
            }
        `
    }}
`

// Results

const ResultsGrid = styled.div`
    display: flex;
    flex-flow: row wrap;
    width: calc(100% + 17px);
    padding: 13px;
    box-sizing: border-box;
    flex: 1 0 auto;

    > * {
        display: flex;
        flex-direction: column;
        flex: 0 1;
        flex-basis: calc(33.3% - 17px);
        margin-right: 17px;
        margin-bottom: 17px;

        ${media.phone`
            flex-basis: calc(100% - 17px);
            margin-bottom: 30px;
        `}
    }
`

const Reference = styled.div``

const Image = styled.div`
    width: 100%;
    height: 16.66vw;
    /* height: 224px; */
    ${bgImage}   
    background-image: url(${props => props.image});
`

const Info = styled.div`
    font-size: 16px;
    color: #000000;  
    margin-top: 7px;
`


const mapDispatchToProps = dispatch => ({
    fetchReferences() {
        dispatch(fetchReferences())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    references: getReferences(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(ImageReferences);




// WEBPACK FOOTER //
// ./client/modules/ImageReferences/ImageReferences.js